import Allergies from '../sections/allergies/allergies';

export default function AllergiesPage() {
  return (
    <div className="section-page">
      <Allergies />
    </div>
  );
}
